import { Paper } from "@mui/material";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { CgProfile } from "react-icons/cg";
import { FaCircleDollarToSlot } from "react-icons/fa6";
import { MdOutlineScience } from "react-icons/md";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

export default function MobileNavigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
  const { t } = useTranslation();

  const getValueFromPath = (pathname) => {
    const prefix = process.env.REACT_APP_PREFIX || "";
    
    switch (pathname) {
      case `${prefix}/payment`:
        return 0;
      case `${prefix}/`:
        return 1;
      case `${prefix}/profile`:
        return 2;
      default:
        return 1;
    }
  };

  const [value, setValue] = React.useState(() => getValueFromPath(location.pathname));

  React.useEffect(() => {
    const newValue = getValueFromPath(location.pathname);
    console.log("ok")
    setValue(newValue);
  }, [location.pathname]);

  const handleNavigationChange = (event, newValue) => {
    setValue(newValue);
    
    const prefix = process.env.REACT_APP_PREFIX || "";
    
    switch (newValue) {
      case 0:
        navigate(`${prefix}/payment`);
        break;
      case 1:
        navigate(`${prefix}/`);
        break;
      case 2:
        navigate(`${prefix}/profile`);
        break;
      default:
        navigate(`${prefix}/`);
    }
  };

  if (!isAuthenticated) {
    return null;
  }

  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "white",
        zIndex: 2000,
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={value}
        onChange={handleNavigationChange}
      >
        <BottomNavigationAction
          label={t("menu_payment")}
          icon={<FaCircleDollarToSlot />}
        />
        <BottomNavigationAction
          label="Home"
          icon={<MdOutlineScience />}
        />
        <BottomNavigationAction
          label={t("menu_profile")}
          icon={<CgProfile />}
        />
      </BottomNavigation>
    </Paper>
  );
}